import React from 'react';

function Header({ onLoginClick }) {
  return (
    <header className="header">
      {/* Top Info Bar */}
      <div className="header-topbar">
        <div className="topbar-inner">
          <div className="topbar-left">
            <span><i>📞</i> 9845462886 / 9742666225 / 9591632626</span>
            <span className="topbar-divider">|</span>
            <span><i>📧</i> info@paramanandacollegeofnursing.com</span>
          </div>
          <div className="topbar-right">
            <a href="#contact" className="topbar-link">📍 Bengaluru, Karnataka</a>
            <a href="/Paramananda_College_of_Nursing_Prospectus.pdf" target="_blank" rel="noopener noreferrer" className="topbar-prospectus-btn">
              📄 Download Prospectus
            </a>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="header-main">
        <div className="header-container">
          <div className="logo">
            <img src="/pcn-logo.jpeg" alt="PCN Logo" className="logo-img" />
            <div className="logo-text">
              <h1>Paramananda College of Nursing</h1>
              <p className="logo-tagline">Compassion &nbsp;|&nbsp; Knowledge &nbsp;|&nbsp; Excellence</p>
              <div className="logo-affiliations">
                <span>Affiliated: RGUHS</span>
                <span className="aff-dot">•</span>
                <span>Approved: INC</span>
                <span className="aff-dot">•</span>
                <span>Karnataka Nursing Council</span>
                <span className="aff-dot">•</span>
                <span>Govt. of Karnataka</span>
              </div>
            </div>
          </div>
          <div className="header-right">
            <div className="header-admission-box">
              <span className="admission-badge">🎓 Admissions Open 2026–27</span>
              <div className="header-btns">
                <a href="#courses" className="btn-apply">Apply Now</a>
                <button className="login-btn" onClick={onLoginClick}>🔐 Login</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;